import { alpha, styled } from "@mui/material";

export const Root = styled("div")({ position: "relative", height: "100%", minHeight: 200 });

export const InputLabel = styled("label", {
  shouldForwardProp: (propName: string) => !["dragHovered", "error"].includes(propName),
})<{
  dragHovered: boolean;
  error: boolean;
}>(({ theme, dragHovered, error }) => {
  const stateColor = error
    ? theme.palette.error.main
    : dragHovered
      ? theme.palette.secondary.main
      : theme.palette.grey[400];
  return {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    border: `2px dashed ${stateColor}`,
    borderRadius: theme.shape.borderRadius,
    cursor: "pointer",
    transition: theme.transitions.create(["background-color", "border-color"], {
      duration: theme.transitions.duration.complex,
    }),
    "&:hover": {
      borderColor: stateColor,
      backgroundColor: alpha(stateColor, 0.2),
    },
    borderColor: dragHovered ? theme.palette.secondary.main : undefined,
    backgroundColor: dragHovered ? alpha(theme.palette.secondary.main, 0.3) : undefined,
  };
});

export const Img = styled("img")({
  margin: "0 auto",
  display: "block",
  maxWidth: 80,
});

export const Input = styled("input")({
  pointerEvents: "all",
  opacity: 0,
  position: "absolute",
  cursor: "pointer",
  width: "100%",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
});
